"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { StoreBadges } from "~/components/app/StoreBadges";
import { Logo } from "~/components/ui/Logo";
import { SOCIAL_LINKS, socialAttr } from "~/lib/constants/social";
const NAV_LINKS = [{
  label: "Blog",
  href: "/blog"
}, {
  label: "Support",
  href: "/support"
}];
const LEGAL_LINKS = [{
  label: "Privacy Policy",
  href: "/privacy"
}, {
  label: "Terms of Service",
  href: "/terms"
}];
export function SiteFooter() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/"><Logo variant="light" sizeClassName="text-[22px]" /></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <nav className="flex flex-wrap gap-x-7 gap-y-3"><Link key="Host your spot" href="/host/onboarding" prefetch={false} className="font-ui text-[13px] font-medium text-[var(--ink-40)] [transition:color_var(--dur-fast)_var(--ease-snap)] hover:text-white">Host your spot</Link>{NAV_LINKS.map(_temp)}</nav>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col flex-wrap gap-x-6 gap-y-5 sm:flex-row sm:items-center sm:justify-between">{t0}{t1}<ul className="-mx-1 flex items-center gap-4">{SOCIAL_LINKS.map(_temp2)}</ul></div>;
    t3 = <div className="my-6 h-px bg-white/10" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <StoreBadges surface="footer" height={34} />;
    t5 = <p className="font-ui text-[12px] text-[var(--ink-40)]">© {2026} EZSpot Inc. All rights reserved.</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <footer className="bg-[var(--ink-80)] px-6 py-8 sm:px-10 md:px-16"><div className="mx-auto max-w-7xl">{t2}{t3}<div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">{t4}{t5}<div className="flex flex-wrap items-center gap-x-5 gap-y-2">{LEGAL_LINKS.map(_temp3)}</div></div></div></footer>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp3(t0) {
  const {
    label: label_1,
    href: href_1
  } = t0;
  return <Link key={label_1} href={href_1} className="font-ui text-[12px] text-[var(--ink-40)] [transition:color_var(--dur-fast)_var(--ease-snap)] hover:text-white">{label_1}</Link>;
}
function _temp2(t0) {
  const {
    name,
    label: label_0,
    href: href_0,
    Icon
  } = t0;
  return <li key={name}><a href={href_0} target="_blank" rel="noreferrer" aria-label={label_0} data-attr={socialAttr(name, "footer")} className="flex rounded-(--r-sm) p-1 text-(--ink-40) [transition:color_var(--dur-fast)_var(--ease-snap)] hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"><Icon aria-hidden="true" className="size-[18px]" /></a></li>;
}
function _temp(t0) {
  const {
    label,
    href
  } = t0;
  return <Link key={label} href={href} prefetch={false} className="font-ui text-[13px] font-medium text-[var(--ink-40)] [transition:color_var(--dur-fast)_var(--ease-snap)] hover:text-white">{label}</Link>;
}